<template>
	<div class="Address" v-if="!loading">
		<div class="popover-mask"></div>
		<div class="popover-close iconfont iconshanchu" @click="bindClose()"></div>
		<el-table :data="list" height="300" style="width:800px;" >
			<el-table-column align='center' min-width="10%" property="" label="选择地址">
				<template slot-scope="scope">
					<div @click='selectAddress(scope.$index)'>
						<span class="iconfont iconxuanzhong" v-if="selectValue.id==scope.row.id"></span>
						<span class="iconfont iconweibiaoti38" v-else></span>
					</div>
				</template>
			</el-table-column>
			<el-table-column align='center' min-width="20%" property="name" label="联系人"></el-table-column>
			<el-table-column align='center' min-width="20%" property="tel" label="联系电话"></el-table-column>
			<el-table-column align='center' min-width="50%" property="address" label="所在地区"></el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		name: 'Address',
		data() {
			return {
				list: [],
				mask: true,
				loading:true
			}
		},

		created: function() {
			this.reload();
		},
		props: {
			selectValue: Object,
		},
		methods: {
			reload: function() {
				this.https.fetchGet('/pc/service/trade/address/index')
					.then((res) => {
						if (res.data.success) {
							var data = res.data.content;
							this.list = data.rows;
							this.loading = false;
						}

					}).catch(err => {
						console.log(err)
					})
			},
			bindClose: function() {
				this.$emit('selectFunc', this.selectValue)
			},
			selectAddress: function(index) {
				this.$emit('selectFunc', this.list[index])
			}
		}

	}
</script>

<style scope>
	.Address {
		position: fixed;
		margin: 0 auto;
		top: 50%;
		left: 50%;
		margin-left: -400px;
		margin-top: -200px;
		height: 300px;
	}

	.popover-close {
		position: absolute;
		right: 10px;
		z-index: 100;
		top: 15px;
		padding: 0 10px;
		cursor: pointer;
	}

	.popover-mask {
		position: fixed;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6);
		
	}

	.iconxuanzhong {
		color: red;
		font-size: 20px;
		cursor: pointer;
	}

	.iconweibiaoti38 {
		font-size: 20px;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/address.vue